import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '@hooks/useAuth';
import useRestaurant from '@hooks/useRestaurant';
import routes from '@routes';
import { createPathWithData } from '@store/utils';

const Dashboard = () => {
    const { isAdmin, loading } = useAuth();
    const { restaurant } = useRestaurant({});

    if (loading) {
        return null;
    }

    if (isAdmin()) {
        return <Navigate to={routes.adminsListPage.path} />;
    }

    if (!restaurant) {
        return null;
    }

    const firstRestaurantId = restaurant[0].id;
    const path = createPathWithData(routes.menuListPage.path, {
        restaurantId: firstRestaurantId,
    });

    return <Navigate to={path} />;
};

export default Dashboard;